import { Select } from "antd";
import React, { useEffect } from "react";
import { useListVideosDurationQuery } from "../redux/Api/VideoApiSlice";
import { toast } from "react-toastify";

const VideoDurationDropdown = ({
  onChange,
  onBlur,
  value,
  className = "",
  title,
}) => {
  const {
    data: videosDuration,
    isLoading,
    error,
  } = useListVideosDurationQuery({
    page: "*",
    ordering: "id",
  });

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat();
      errorMessages.forEach((message) => {
        toast.error(message);
      });
    }
  }, [error]);

  return (
    <div>
      <label className="form-label">{title}</label>
      <br />
      <Select
        className={className}
        name="take_down_duration"
        showSearch
        style={{
          width: "100%",
        }}
        optionFilterProp="label"
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? "")
            .toLowerCase()
            .localeCompare((optionB?.label ?? "").toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={videosDuration?.results?.map((x) => {
          return { label: x.duration, value: x.id };
        })}
      />
    </div>
  );
};

export default VideoDurationDropdown;
